import * as Skeleton from "@/components/skeleton/Skeleton";
import { twMerge } from "@/utils/twMerge";

const SkeletonBlock = ({ className }: { className?: string }) => {
  return (
    <div className={twMerge("mb-[15px]", className)}>
      <Skeleton.Block className="w-full max-w-[97%] h-[23px] mb-[6px] bg-gray-200 dark:bg-gray-800 rounded-full" />
      <Skeleton.Block className="w-full max-w-[92%] h-[23px] mb-[6px] bg-gray-200 dark:bg-gray-800 rounded-full" />
      <Skeleton.Block className="w-full max-w-[95%] h-[23px] mb-[6px] bg-gray-200 dark:bg-gray-800 rounded-full" />
      <Skeleton.Block className="w-full max-w-[75%] h-[23px] bg-gray-200 dark:bg-gray-800 rounded-full" />
    </div>
  );
};

export const DocumentSkeleton = () => {
  return (
    <Skeleton.Root className={twMerge("py-14 px-12", "sm:mt-10 sm:px-6 sm:pt-7")}>
      <Skeleton.Block className="w-full h-[44px] mb-[6px] bg-gray-200 dark:bg-gray-800 rounded-full" />
      <Skeleton.Block className="w-full max-w-[241px] h-[23px] mb-[47px] bg-gray-200 dark:bg-gray-800 rounded-full" />
      <SkeletonBlock />
      <SkeletonBlock />
      <div className="relative">
        <SkeletonBlock className="" />
        <div className="pointer-events-none absolute inset-x-0 bottom-0 h-[160px] bg-gradient-to-b from-transparent to-white dark:to-black z-10" />
      </div>
    </Skeleton.Root>
  );
};
